// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Typography,
//   Box,
//   Button,
//   IconButton,
//   Divider,
//   CircularProgress,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { BASE_URL } from "../../Api/ApiUrls";
// import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";


// const JDJVPropertyDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [locationLoading, setLocationLoading] = useState(false);

//  useEffect(() => {
//   const fetchProperty = async () => {
//     try {
//       setLoading(true);

//       const res = await axios.get(`${BASE_URL}/property/${id}/`);

//       // If API returns property directly
//       setProperty(res.data.data || res.data);

//     } catch (err) {
//       console.error("Error fetching property:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchProperty();
// }, [id]);

//   const formatPropertyId = (id) => {
//     return `PR${String(id).padStart(4, '0')}`;
//   };

//   const formatPrice = (amount) => {
//     if (!amount || amount === 0) return "Not specified";
    
//     if (amount >= 10000000) {
//       return `₹${(amount / 10000000).toFixed(1)} Cr`;
//     } else if (amount >= 100000) {
//       return `₹${(amount / 100000).toFixed(1)} L`;
//     } else {
//       return `₹${amount.toLocaleString()}`;
//     }
//   };

//   const handleLocationClick = () => {
//     if (!property) {
//       window.alert("Property data not available");
//       return;
//     }
    
//     // Get coordinates directly from property object (new API structure)
//     const lat = property.lat;
//     const lng = property.long;
    
//     if (!lat || !lng) {
//       window.alert("Location coordinates not available");
//       return;
//     }
    
//     setLocationLoading(true);
    
//     const openInMaps = (url) => {
//       setLocationLoading(false);
//       window.open(url, '_blank', 'noopener,noreferrer');
//     };

//     const locationString = `${lat},${lng}`;
//     const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationString)}`;
    
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const userLat = position.coords.latitude;
//           const userLng = position.coords.longitude;
          
//           const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${lat},${lng}&travelmode=driving`;
//           openInMaps(mapsUrl);
//         },
//         (error) => {
//           console.error("Error getting location:", error);
//           openInMaps(fallbackUrl);
//         },
//         { timeout: 10000 }
//       );
//     } else {
//       openInMaps(fallbackUrl);
//     }
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }
  
//   if (!property) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center' }}>
//         <Typography>JD/JV Property not found</Typography>
//       </Box>
//     );
//   }

//   // Get property ID for display
//   const displayId = property.property_id || property.req_id;
  
//   // Get location directly from property (new API structure)
//   const propertyLocation = property.location || "Not specified";

//   return (
//     <Box sx={{ 
//       pb: 0,
//       height: '100vh',
//       display: 'flex',
//       flexDirection: 'column'
//     }}>
//       <Box sx={{ 
//         flex: 1,
//         overflowY: 'auto',
//         paddingLeft: '8px',
//         paddingRight: '8px',
//         paddingTop: '2px',
//         paddingBottom: '2px'
//       }}>
//         <Card sx={{ 
//           maxWidth: 420, 
//           mx: "auto",
//           mb: 2
//         }}>
//           {/* Header - Fixed at top of card */}
//           <Box
//             sx={{
//               backgroundColor: "black",
//               color: "#fff",
//               px: 2,
//               py: 1,
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               borderTopLeftRadius: 8,
//               borderTopRightRadius: 8,
//               position: 'sticky',
//               top: 0,
//               zIndex: 10
//             }}
//           >
//             <IconButton
//               size="small"
//               sx={{ color: "#fff" }}
//               onClick={() => navigate(-1)}
//             >
//               <ArrowBackIosNewIcon fontSize="small" />
//             </IconButton>

//             <Typography fontWeight={600} flexGrow={1}>
//               JD/JV Property
//             </Typography>

//             <Box textAlign="right">
//               <Typography variant="caption">
//                 ID: {formatPropertyId(displayId)}
//               </Typography>
//               <Typography variant="caption" display="block">
//                 Date:{" "}
//                 {new Date(property.created_at).toLocaleDateString("en-GB")}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Scrollable Card Content */}
//           <Box sx={{ 
//             maxHeight: 'calc(100vh - 120px)',
//             overflowY: 'auto',
//             paddingLeft: '8px',
//             paddingRight: '8px',
//             paddingTop: '2px',
//             paddingBottom: '2px'
//           }}>
//             {/* Budget Range */}
//             <Box
//               sx={{
//                 backgroundColor: "#fff1f0",
//                 p: 2,
//                 borderRadius: 2,
//                 mb: 2,
//               }}
//             >
//               <Typography variant="body2" color="text.secondary">
//                 Budget Range
//               </Typography>
//               <Typography variant="h6" color="error" fontWeight={700}>
//                 {formatPrice(property.min_budget)} - {formatPrice(property.max_budget)}
//               </Typography>
//             </Box>

//             {/* Property Info */}
//             <Typography variant="body2">
//               <b>Looking for:</b> {property.type ? property.type.toUpperCase() : "Not specified"}
//             </Typography>

//             <Typography variant="body2" mt={1}>
//               <b>Property type:</b> {property.property_type || "Not specified"}
//             </Typography>

// <Box mt={1}>
//   <Box
//     onClick={handleLocationClick}
//     sx={{
//       cursor: "pointer",
//       borderRadius: 1,
//       p: 0.5,
//       "&:hover": {
//         backgroundColor: "#f0f0f0",
//       },
//     }}
//   >
//     {/* First Row */}
//     <Box sx={{ display: "flex", alignItems: "center" }}>
//       <Typography variant="body2">
//         <b>Location:</b>
//       </Typography>

//       {locationLoading ? (
//         <CircularProgress size={16} sx={{ ml: 0.5 }} />
//       ) : (
//         <LocationOnIcon
//           sx={{ color: "#1976d2", fontSize: "1rem", ml: 0.5 }}
//         />
//       )}
      
//       <Typography variant="body2" sx={{ ml: 1, color: "#555" }}>
//         {property.location?.split(",")[0]}
//       </Typography>
//     </Box>

//     {/* Second Row (remaining address) */}
//     <Typography
//      variant="body2"
//   sx={{
//     color: "#555",
//     lineHeight: 1.4,          // ✅ more vertical spacing
//     textAlign: "justify",     // ✅ left + right align
//    // ✅ better spacing between words
//                      // ✅ more gap from above
    
//   }}
// >
//       {property.location
//         }
//     </Typography>
//   </Box>
// </Box>



//             {/* Additional Details Box */}
//             <Box
//               sx={{
//                 backgroundColor: "#f0f7ff",
//                 p: 2,
//                 borderRadius: 2,
//                 mt: 2,
//               }}
//             >
//               <InfoRow 
//                 label="Minimum Budget" 
//                 value={formatPrice(property.min_budget)} 
//               />
//               <InfoRow 
//                 label="Maximum Budget" 
//                 value={formatPrice(property.max_budget)} 
//               />
//               {property.min_acres > 0 && (
//                 <InfoRow 
//                   label="Minimum Acres" 
//                   value={`${property.min_acres} acres`} 
//                 />
//               )}

//         {property.ratio && (
//                 <InfoRow 
//                   label="JV/JD Ratio" 
//                   value={property.ratio} 
//                 />
//               )}

//             {property.length > 0 && (
//   <InfoRow
//     label="Length"
//     value={`${property.length} ft`}
//   />
// )}

// {property.width > 0 && (
//   <InfoRow
//     label="Width"
//     value={`${property.width} ft`}
//   />
// )}

//               {property.max_acres > 0 && (
//                 <InfoRow 
//                   label="Maximum Acres" 
//                   value={`${property.max_acres} acres`} 
//                 />
//               )}
              
//               {/* New fields from the API */}
//               {property.posted_by && (
//                 <InfoRow 
//                   label="Posted By" 
//                   value={property.posted_by} 
//                 />
//               )}
              
//               {(property.roadwidth > 0 || property.road_width > 0) && (
//                 <InfoRow 
//                   label="Road Width" 
//                   value={`${property.roadwidth || property.road_width} ft`} 
//                 />
//               )}
//                           {/* <InfoRow
//   label="Units"
//   value={property.units || "Not specified"}
// /> */}
              
//               {property.facing && (
//                 <InfoRow 
//                   label="Facing" 
//                   value={property.facing} 
//                 />
//               )}
//              {property.facing && (
//   <InfoRow
//     label="Date"
//     value={
//       property.created_at
//         ? new Date(property.created_at).toLocaleDateString("en-IN", {
//             day: "2-digit",
//             month: "2-digit",
//             year: "numeric",
//           })
//         : "-"
//     }
//   />
// )}

//             </Box>

//             <Divider sx={{ my: 2 }} />

//             {/* Description/Comment Section - FIXED */}
//             {/* {(property.description || property.comment) && (
//               <Box
//                 sx={{
//                   border: "1px solid #ddd",
//                   borderRadius: 2,
//                   mt: 2,
//                   p: 2,
//                   minHeight: 80,
//                 }}
//               >
//                 <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                   {property.description ? "Description" : "Additional Comments"}:
//                 </Typography>
//                 <Typography variant="body2">
//                   {property.description || property.comment}
//                 </Typography>
//               </Box>
//             )} */}
//           </Box>
//         </Card>
//       </Box>

//       {/* Fixed Bottom Navbar */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
//         <FormsBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// /* Reusable Row */
// const InfoRow = ({ label, value }) => (
//   <Box display="flex" justifyContent="space-between" mb={1}>
//     <Typography variant="body2" color="text.secondary">
//       {label}
//     </Typography>
//     <Typography variant="body2" fontWeight={600}>
//       {value}
//     </Typography>
//   </Box>
// );

// export default JDJVPropertyDetail;



// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Typography,
//   Box,
//   Button,
//   IconButton,
//   Divider,
//   CircularProgress,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import HomeWorkIcon from "@mui/icons-material/HomeWork";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MapIcon from "@mui/icons-material/Map";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import PercentIcon from "@mui/icons-material/Percent";
// import StraightenIcon from "@mui/icons-material/Straighten";
// import HeightIcon from "@mui/icons-material/Height";
// import PersonIcon from "@mui/icons-material/Person";
// import AddRoadIcon from "@mui/icons-material/AddRoad";
// import ExploreIcon from "@mui/icons-material/Explore";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { BASE_URL } from "../../Api/ApiUrls";
// import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";

// const JDJVPropertyDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [locationLoading, setLocationLoading] = useState(false);
//   const [detailsExpanded, setDetailsExpanded] = useState(true);

//   useEffect(() => {
//     const fetchProperty = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${BASE_URL}/property/${id}/`);
//         setProperty(res.data.data || res.data);
//       } catch (err) {
//         console.error("Error fetching property:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProperty();
//   }, [id]);

//   const formatPropertyId = (id) => `PR${String(id).padStart(4, "0")}`;

//   const formatPrice = (amount) => {
//     if (!amount || amount === 0) return "Not specified";
//     if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(1)} Cr`;
//     if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)} L`;
//     return `₹${amount.toLocaleString()}`;
//   };

//   const handleLocationClick = () => {
//     if (!property) {
//       window.alert("Property data not available");
//       return;
//     }
//     const lat = property.lat;
//     const lng = property.long;
//     if (!lat || !lng) {
//       window.alert("Location coordinates not available");
//       return;
//     }
//     setLocationLoading(true);
//     const openInMaps = (url) => {
//       setLocationLoading(false);
//       window.open(url, "_blank", "noopener,noreferrer");
//     };
//     const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//       `${lat},${lng}`
//     )}`;
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${position.coords.latitude},${position.coords.longitude}&destination=${lat},${lng}&travelmode=driving`;
//           openInMaps(mapsUrl);
//         },
//         () => openInMaps(fallbackUrl),
//         { timeout: 10000 }
//       );
//     } else {
//       openInMaps(fallbackUrl);
//     }
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//           backgroundColor: "#F8F3EC",
//         }}
//       >
//         <CircularProgress sx={{ color: "#8A6A3D" }} />
//       </Box>
//     );
//   }

//   if (!property) {
//     return (
//       <Box sx={{ p: 2, textAlign: "center", backgroundColor: "#F8F3EC", minHeight: "100vh" }}>
//         <Typography>JD/JV Property not found</Typography>
//       </Box>
//     );
//   }

//   const displayId = property.property_id || property.req_id;
//   const propertyLocation = property.location || "Not specified";
//   const dateStr = property.created_at
//     ? new Date(property.created_at).toLocaleDateString("en-GB")
//     : "-";

//   return (
//     <Box
//       sx={{
//         width: "100vw",
//         minHeight: "100vh",
//         backgroundColor: "#F8F3EC",
//         pb: 10,
//       }}
//     >
//       {/* ===== FIXED HEADER (dark brown) ===== */}
//       <Box
//         sx={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 10,
//           bgcolor: "#3E2A1E",
//           color: "white",
//           px: 2,
//           py: 1.5,
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <IconButton
//           onClick={() => navigate(-1)}
//           sx={{ color: "white", mr: 1, p: 0.5 }}
//         >
//           <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
//         </IconButton>
//         <Typography
//           sx={{
//             flex: 1,
//             fontSize: "1rem",
//             fontWeight: 600,
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           JD/JV Property
//         </Typography>

//         {/* <Box textAlign="right">
//           <Typography
//             sx={{ display: "block", fontSize: "0.66rem", opacity: 0.9, lineHeight: 1.2 }}
//           >
//             ID: {formatPropertyId(displayId)}
//           </Typography>
        
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "flex-end",
//               gap: 0.4,
//               mt: 0.2,
//             }}
//           >
//             <CalendarTodayIcon sx={{ fontSize: 10, opacity: 0.9 }} />
//             <Typography sx={{ fontSize: "0.64rem", opacity: 0.9 }}>
//               Date: {dateStr}
//             </Typography>
//           </Box>
//         </Box> */}
//       </Box>

//       {/* ===== BODY ===== */}
//       <Box sx={{ pt: "60px", px: 1 }}>
//         {/* ── Budget Range card ── */}
//         <Box
//           sx={{
//             bgcolor: "#FFFFFF",
//             border: "1px solid #E8DCC8",
//             borderRadius: "12px",
//             p: 1.5,
//             mb: 1.5,
//             display: "flex",
//             alignItems: "center",
//             gap: 1.2,
//           }}
//         >
//           <Box
//             sx={{
//               width: 42,
//               height: 42,
//               borderRadius: "50%",
//               backgroundColor: "#FBF5ED",
//               border: "1px solid #E8DCC8",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <MonetizationOnIcon sx={{ color: "#8A6A3D", fontSize: 22 }} />
//           </Box>

//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Budget Range
//             </Typography>
//             <Typography
//               sx={{
//                 color: "#5C3D1E",
//                 fontWeight: 800,
//                 fontSize: "1rem",
//                 lineHeight: 1.2,
//               }}
//             >
//               {formatPrice(property.min_budget)} - {formatPrice(property.max_budget)}
//             </Typography>
//           </Box>

//           <Divider
//             orientation="vertical"
//             flexItem
//             sx={{ mx: 0.5, borderColor: "#E8DCC8" }}
//           />

//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               flexShrink: 0,
//             }}
//           >
//             <Box
//               sx={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: "50%",
//                 backgroundColor: "#FBF5ED",
//                 border: "1px solid #E8DCC8",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <BarChartIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
//             </Box>
//             <Box>
//               <Typography
//                 sx={{
//                   fontSize: "0.78rem",
//                   fontWeight: 700,
//                   color: "#222",
//                   lineHeight: 1.1,
//                 }}
//               >
//                 {property.property_type || "Plot"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.66rem", color: "#777" }}>
//                 Property Type
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* ── Looking for ── */}
//         <InfoIconRow
//           icon={<SearchIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />}
//           label="Looking for:"
//           value={property.type ? property.type.toUpperCase() : "Not specified"}
//         />

//         {/* ── Property type + View on Map ── */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
//           <IconCircle>
//             <HomeWorkIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
//           </IconCircle>
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Property type:
//             </Typography>
//             <Typography
//               sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}
//             >
//               {property.property_type || "Not specified"}
//             </Typography>
//           </Box>
//           <Button
//             size="small"
//             onClick={handleLocationClick}
//             startIcon={<MapIcon sx={{ fontSize: 14 }} />}
//             sx={{
//               textTransform: "none",
//               fontSize: "0.72rem",
//               fontWeight: 600,
//               color: "#5C3D1E",
//               backgroundColor: "#F5DEB3",
//               border: "1px solid #E8C99A",
//               borderRadius: 999,
//               px: 1.2,
//               py: 0.4,
//               "&:hover": { backgroundColor: "#eccf95" },
//             }}
//           >
//             View on Map
//           </Button>
//         </Box>

//         {/* ── Location ── */}
//         <Box
//           onClick={handleLocationClick}
//           sx={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: 1.2,
//             mb: 2,
//             cursor: "pointer",
//             borderRadius: 1,
//             p: 0.4,
//             "&:hover": { backgroundColor: "#F0E6D6" },
//           }}
//         >
//           <IconCircle>
//             {locationLoading ? (
//               <CircularProgress size={14} sx={{ color: "#8A6A3D" }} />
//             ) : (
//               <LocationOnIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
//             )}
//           </IconCircle>
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Location:
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.85rem",
//                 fontWeight: 600,
//                 color: "#222",
//                 lineHeight: 1.3,
//               }}
//             >
//               {propertyLocation}
//             </Typography>
//           </Box>
//         </Box>

//         {/* ── Property Details (collapsible, matching Buy_description style) ── */}
//         <Box sx={{ mb: 1.5 }}>
//           <Accordion
//             expanded={detailsExpanded}
//             onChange={() => setDetailsExpanded(!detailsExpanded)}
//             sx={{
//               borderRadius: "12px !important",
//               border: "1px solid #E8DCC8",
//               boxShadow: "none",
//               bgcolor: "#FFFFFF",
//               "&:before": { display: "none" },
//               "&.Mui-expanded": { margin: 0 },
//             }}
//           >
//             <AccordionSummary
//               expandIcon={<ExpandMoreIcon sx={{ color: "#8A6A3D" }} />}
//               sx={{ px: 1.5, minHeight: 48, "&.Mui-expanded": { minHeight: 48 } }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                 <ApartmentIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
//                 <Typography
//                   sx={{ fontSize: "0.95rem", fontWeight: 700, color: "#222" }}
//                 >
//                   Property Details
//                 </Typography>
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails sx={{ px: 1.5, pt: 0 }}>
//               <Box sx={{ borderTop: "1px solid #F0E6D6", pt: 1.2 }}>
//                 <DetailRow
//                   icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
//                   label="Minimum Budget"
//                   value={formatPrice(property.min_budget)}
//                 />
//                 <DetailRow
//                   icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
//                   label="Maximum Budget"
//                   value={formatPrice(property.max_budget)}
//                 />
//                 {property.ratio && (
//                   <DetailRow
//                     icon={<PercentIcon sx={{ fontSize: 14 }} />}
//                     label="JV/JD Ratio"
//                     value={property.ratio}
//                   />
//                 )}
//                 {property.length > 0 && (
//                   <DetailRow
//                     icon={<StraightenIcon sx={{ fontSize: 14 }} />}
//                     label="Length"
//                     value={`${property.length} ft`}
//                   />
//                 )}
//                 {property.width > 0 && (
//                   <DetailRow
//                     icon={<HeightIcon sx={{ fontSize: 14 }} />}
//                     label="Width"
//                     value={`${property.width} ft`}
//                   />
//                 )}
//                 {property.posted_by && (
//                   <DetailRow
//                     icon={<PersonIcon sx={{ fontSize: 14 }} />}
//                     label="Posted By"
//                     value={property.posted_by}
//                   />
//                 )}
//                 {(property.roadwidth > 0 || property.road_width > 0) && (
//                   <DetailRow
//                     icon={<AddRoadIcon sx={{ fontSize: 14 }} />}
//                     label="Road Width"
//                     value={`${property.roadwidth || property.road_width} ft`}
//                   />
//                 )}
//                 {property.facing && (
//                   <DetailRow
//                     icon={<ExploreIcon sx={{ fontSize: 14 }} />}
//                     label="Facing"
//                     value={property.facing}
//                   />
//                 )}
//                 {/* ✅ Date also inside Property Details */}
//                 <DetailRow
//                   icon={<CalendarTodayIcon sx={{ fontSize: 14 }} />}
//                   label="Date"
//                   value={
//                     property.created_at
//                       ? new Date(property.created_at).toLocaleDateString(
//                           "en-IN",
//                           {
//                             day: "2-digit",
//                             month: "2-digit",
//                             year: "numeric",
//                           }
//                         )
//                       : "-"
//                   }
//                 />
//               </Box>
//             </AccordionDetails>
//           </Accordion>
//         </Box>
//       </Box>

//       {/* Fixed bottom nav */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
//         <FormsBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// /* ───────── Reusable subcomponents (Buy_description color palette) ───────── */

// const IconCircle = ({ children }) => (
//   <Box
//     sx={{
//       width: 36,
//       height: 36,
//       borderRadius: "50%",
//       backgroundColor: "#FBF5ED",
//       border: "1px solid #E8DCC8",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexShrink: 0,
//     }}
//   >
//     {children}
//   </Box>
// );

// const InfoIconRow = ({ icon, label, value }) => (
//   <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
//     <IconCircle>{icon}</IconCircle>
//     <Box sx={{ flex: 1, minWidth: 0 }}>
//       <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>{label}</Typography>
//       <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}>
//         {value}
//       </Typography>
//     </Box>
//   </Box>
// );

// const DetailRow = ({ icon, label, value }) => (
//   <Box
//     sx={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       py: 1.1,
//       borderBottom: "1px solid #F0E6D6",
//       "&:last-of-type": { borderBottom: "none" },
//     }}
//   >
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//       <Box
//         sx={{
//           width: 26,
//           height: 26,
//           borderRadius: "50%",
//           backgroundColor: "#FBF5ED",
//           border: "1px solid #E8DCC8",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "#8A6A3D",
//           flexShrink: 0,
//         }}
//       >
//         {icon}
//       </Box>
//       <Typography
//         sx={{ fontSize: "0.8rem", color: "#555", fontWeight: 500 }}
//       >
//         {label}
//       </Typography>
//     </Box>
//     <Typography
//       sx={{ fontSize: "0.84rem", fontWeight: 700, color: "#222" }}
//     >
//       {value}
//     </Typography>
//   </Box>
// );

// export default JDJVPropertyDetail;



// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Typography,
//   Box,
//   Button,
//   IconButton,
//   Divider,
//   CircularProgress,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import HomeWorkIcon from "@mui/icons-material/HomeWork";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MapIcon from "@mui/icons-material/Map";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import PercentIcon from "@mui/icons-material/Percent";
// import StraightenIcon from "@mui/icons-material/Straighten";
// import HeightIcon from "@mui/icons-material/Height";
// import PersonIcon from "@mui/icons-material/Person";
// import AddRoadIcon from "@mui/icons-material/AddRoad";
// import ExploreIcon from "@mui/icons-material/Explore";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CallIcon from "@mui/icons-material/Call";
// import TagIcon from "@mui/icons-material/Tag";
// import { BASE_URL } from "../../Api/ApiUrls";
// import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";

// const JDJVPropertyDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [locationLoading, setLocationLoading] = useState(false);
//   const [detailsExpanded, setDetailsExpanded] = useState(true);

//   useEffect(() => {
//     const fetchProperty = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${BASE_URL}/property/${id}/`);
//         setProperty(res.data.data || res.data);
//       } catch (err) {
//         console.error("Error fetching property:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProperty();
//   }, [id]);

//   const formatPropertyId = (id) => `PR${String(id).padStart(4, "0")}`;

//   const formatPrice = (amount) => {
//     if (!amount || amount === 0) return "Not specified";
//     if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(1)} Cr`;
//     if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)} L`;
//     return `₹${amount.toLocaleString()}`;
//   };

//   const handleLocationClick = () => {
//     if (!property) {
//       window.alert("Property data not available");
//       return;
//     }
//     const lat = property.lat;
//     const lng = property.long;
//     if (!lat || !lng) {
//       window.alert("Location coordinates not available");
//       return;
//     }
//     setLocationLoading(true);
//     const openInMaps = (url) => {
//       setLocationLoading(false);
//       window.open(url, "_blank", "noopener,noreferrer");
//     };
//     const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//       `${lat},${lng}`
//     )}`;
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${position.coords.latitude},${position.coords.longitude}&destination=${lat},${lng}&travelmode=driving`;
//           openInMaps(mapsUrl);
//         },
//         () => openInMaps(fallbackUrl),
//         { timeout: 10000 }
//       );
//     } else {
//       openInMaps(fallbackUrl);
//     }
//   };

//   // ✅ NEW: Contact handler — copies the mobile number to clipboard
//   const handleContactClick = async () => {
//     if (!property) return;
//     const mobile = property.mobile_no || property.mobile || property.phone;
//     if (!mobile) {
//       window.alert("Mobile number not available");
//       return;
//     }
//     try {
//       await navigator.clipboard.writeText(mobile);
//       window.alert(`Contact number copied: ${mobile}`);
//     } catch (err) {
//       console.error("Clipboard error:", err);
//       window.alert(`Contact number: ${mobile}`);
//     }
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//           backgroundColor: "#F8F3EC",
//         }}
//       >
//         <CircularProgress sx={{ color: "#8A6A3D" }} />
//       </Box>
//     );
//   }

//   if (!property) {
//     return (
//       <Box sx={{ p: 2, textAlign: "center", backgroundColor: "#F8F3EC", minHeight: "100vh" }}>
//         <Typography>JD/JV Property not found</Typography>
//       </Box>
//     );
//   }

//   const displayId = property.property_id || property.req_id;
//   const propertyLocation = property.location || "Not specified";
//   const dateStr = property.created_at
//     ? new Date(property.created_at).toLocaleDateString("en-GB")
//     : "-";

//   return (
//     <Box
//       sx={{
//         width: "100vw",
//         minHeight: "100vh",
//         backgroundColor: "#F8F3EC",
//         pb: 10,
//       }}
//     >
//       {/* ===== FIXED HEADER (dark brown) ===== */}
//       <Box
//         sx={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 10,
//           bgcolor: "#3E2A1E",
//           color: "white",
//           px: 2,
//           py: 1.5,
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <IconButton
//           onClick={() => navigate(-1)}
//           sx={{ color: "white", mr: 1, p: 0.5 }}
//         >
//           <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
//         </IconButton>
//         <Typography
//           sx={{
//             flex: 1,
//             fontSize: "1rem",
//             fontWeight: 600,
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           JD/JV Property
//         </Typography>
//       </Box>

//       {/* ===== BODY ===== */}
//       <Box sx={{ pt: "60px", px: 1 }}>
//         {/* ── Budget Range card ── */}
//         <Box
//           sx={{
//             bgcolor: "#FFFFFF",
//             border: "1px solid #E8DCC8",
//             borderRadius: "12px",
//             p: 1.5,
//             mb: 1.5,
//             display: "flex",
//             alignItems: "center",
//             gap: 1.2,
//           }}
//         >
//           <Box
//             sx={{
//               width: 42,
//               height: 42,
//               borderRadius: "50%",
//               backgroundColor: "#FBF5ED",
//               border: "1px solid #E8DCC8",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <MonetizationOnIcon sx={{ color: "#8A6A3D", fontSize: 22 }} />
//           </Box>

//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Budget Range
//             </Typography>
//             <Typography
//               sx={{
//                 color: "#5C3D1E",
//                 fontWeight: 800,
//                 fontSize: "1rem",
//                 lineHeight: 1.2,
//               }}
//             >
//               {formatPrice(property.min_budget)} - {formatPrice(property.max_budget)}
//             </Typography>
//           </Box>

//           <Divider
//             orientation="vertical"
//             flexItem
//             sx={{ mx: 0.5, borderColor: "#E8DCC8" }}
//           />

//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               flexShrink: 0,
//             }}
//           >
//             <Box
//               sx={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: "50%",
//                 backgroundColor: "#FBF5ED",
//                 border: "1px solid #E8DCC8",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <BarChartIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
//             </Box>
//             <Box>
//               <Typography
//                 sx={{
//                   fontSize: "0.78rem",
//                   fontWeight: 700,
//                   color: "#222",
//                   lineHeight: 1.1,
//                 }}
//               >
//                 {property.property_type || "Plot"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.66rem", color: "#777" }}>
//                 Property Type
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* ── Looking for ── */}
//         <InfoIconRow
//           icon={<SearchIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />}
//           label="Looking for:"
//           value={property.type ? property.type.toUpperCase() : "Not specified"}
//         />

//         {/* ── Property type + View on Map ── */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
//           <IconCircle>
//             <HomeWorkIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
//           </IconCircle>
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Property type:
//             </Typography>
//             <Typography
//               sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}
//             >
//               {property.property_type || "Not specified"}
//             </Typography>
//           </Box>
//           <Button
//             size="small"
//             onClick={handleLocationClick}
//             startIcon={<MapIcon sx={{ fontSize: 14 }} />}
//             sx={{
//               textTransform: "none",
//               fontSize: "0.72rem",
//               fontWeight: 600,
//               color: "#5C3D1E",
//               backgroundColor: "#F5DEB3",
//               border: "1px solid #E8C99A",
//               borderRadius: 999,
//               px: 1.2,
//               py: 0.4,
//               "&:hover": { backgroundColor: "#eccf95" },
//             }}
//           >
//             View on Map
//           </Button>
//         </Box>

//         {/* ── Location ── */}
//         <Box
//           onClick={handleLocationClick}
//           sx={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: 1.2,
//             mb: 2,
//             cursor: "pointer",
//             borderRadius: 1,
//             p: 0.4,
//             "&:hover": { backgroundColor: "#F0E6D6" },
//           }}
//         >
//           <IconCircle>
//             {locationLoading ? (
//               <CircularProgress size={14} sx={{ color: "#8A6A3D" }} />
//             ) : (
//               <LocationOnIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
//             )}
//           </IconCircle>
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Location:
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.85rem",
//                 fontWeight: 600,
//                 color: "#222",
//                 lineHeight: 1.3,
//               }}
//             >
//               {propertyLocation}
//             </Typography>
//           </Box>
//         </Box>

//         {/* ── Property Details (collapsible) ── */}
//         <Box sx={{ mb: 1.5 }}>
//           <Accordion
//             expanded={detailsExpanded}
//             onChange={() => setDetailsExpanded(!detailsExpanded)}
//             sx={{
//               borderRadius: "12px !important",
//               border: "1px solid #E8DCC8",
//               boxShadow: "none",
//               bgcolor: "#FFFFFF",
//               "&:before": { display: "none" },
//               "&.Mui-expanded": { margin: 0 },
//             }}
//           >
//             <AccordionSummary
//               expandIcon={<ExpandMoreIcon sx={{ color: "#8A6A3D" }} />}
//               sx={{ px: 1.5, minHeight: 48, "&.Mui-expanded": { minHeight: 48 } }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                 <ApartmentIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
//                 <Typography
//                   sx={{ fontSize: "0.95rem", fontWeight: 700, color: "#222" }}
//                 >
//                   Property Details
//                 </Typography>
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails sx={{ px: 1.5, pt: 0 }}>
//               <Box sx={{ borderTop: "1px solid #F0E6D6", pt: 1.2 }}>
//                 {/* ✅ NEW: Property ID row */}
//                 {displayId && (
//                   <DetailRow
//                     icon={<TagIcon sx={{ fontSize: 14 }} />}
//                     label="Property ID"
//                     value={formatPropertyId(displayId)}
//                   />
//                 )}

//                 <DetailRow
//                   icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
//                   label="Minimum Budget"
//                   value={formatPrice(property.min_budget)}
//                 />
//                 <DetailRow
//                   icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
//                   label="Maximum Budget"
//                   value={formatPrice(property.max_budget)}
//                 />
//                 {property.ratio && (
//                   <DetailRow
//                     icon={<PercentIcon sx={{ fontSize: 14 }} />}
//                     label="JV/JD Ratio"
//                     value={property.ratio}
//                   />
//                 )}
//                 {property.length > 0 && (
//                   <DetailRow
//                     icon={<StraightenIcon sx={{ fontSize: 14 }} />}
//                     label="Length"
//                     value={`${property.length} ft`}
//                   />
//                 )}
//                 {property.width > 0 && (
//                   <DetailRow
//                     icon={<HeightIcon sx={{ fontSize: 14 }} />}
//                     label="Width"
//                     value={`${property.width} ft`}
//                   />
//                 )}
//                 {property.posted_by && (
//                   <DetailRow
//                     icon={<PersonIcon sx={{ fontSize: 14 }} />}
//                     label="Posted By"
//                     value={property.posted_by}
//                   />
//                 )}
//                 {(property.roadwidth > 0 || property.road_width > 0) && (
//                   <DetailRow
//                     icon={<AddRoadIcon sx={{ fontSize: 14 }} />}
//                     label="Road Width"
//                     value={`${property.roadwidth || property.road_width} ft`}
//                   />
//                 )}
//                 {property.facing && (
//                   <DetailRow
//                     icon={<ExploreIcon sx={{ fontSize: 14 }} />}
//                     label="Facing"
//                     value={property.facing}
//                   />
//                 )}
//                 <DetailRow
//                   icon={<CalendarTodayIcon sx={{ fontSize: 14 }} />}
//                   label="Date"
//                   value={
//                     property.created_at
//                       ? new Date(property.created_at).toLocaleDateString(
//                           "en-IN",
//                           {
//                             day: "2-digit",
//                             month: "2-digit",
//                             year: "numeric",
//                           }
//                         )
//                       : "-"
//                   }
//                 />

//                 {/* ✅ NEW: Contact button inside Property Details */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     mt: 1.5,
//                   }}
//                 >
//                   <Button
//                     size="small"
//                     variant="contained"
//                     onClick={handleContactClick}
//                     startIcon={<CallIcon sx={{ fontSize: 15 }} />}
//                     sx={{
//                       textTransform: "none",
//                       fontSize: "0.78rem",
//                       fontWeight: 700,
//                       color: "#FFFFFF",
//                       backgroundColor: "#8A6A3D",
//                       borderRadius: 999,
//                       px: 2,
//                       py: 0.6,
//                       boxShadow: "0 2px 6px rgba(138,106,61,0.35)",
//                       "&:hover": { backgroundColor: "#75592F" },
//                     }}
//                   >
//                     Contact
//                   </Button>
//                 </Box>
//               </Box>
//             </AccordionDetails>
//           </Accordion>
//         </Box>
//       </Box>

//       {/* Fixed bottom nav */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
//         <FormsBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// /* ───────── Reusable subcomponents ───────── */

// const IconCircle = ({ children }) => (
//   <Box
//     sx={{
//       width: 36,
//       height: 36,
//       borderRadius: "50%",
//       backgroundColor: "#FBF5ED",
//       border: "1px solid #E8DCC8",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexShrink: 0,
//     }}
//   >
//     {children}
//   </Box>
// );

// const InfoIconRow = ({ icon, label, value }) => (
//   <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
//     <IconCircle>{icon}</IconCircle>
//     <Box sx={{ flex: 1, minWidth: 0 }}>
//       <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>{label}</Typography>
//       <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}>
//         {value}
//       </Typography>
//     </Box>
//   </Box>
// );

// const DetailRow = ({ icon, label, value }) => (
//   <Box
//     sx={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       py: 1.1,
//       borderBottom: "1px solid #F0E6D6",
//       "&:last-of-type": { borderBottom: "none" },
//     }}
//   >
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//       <Box
//         sx={{
//           width: 26,
//           height: 26,
//           borderRadius: "50%",
//           backgroundColor: "#FBF5ED",
//           border: "1px solid #E8DCC8",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "#8A6A3D",
//           flexShrink: 0,
//         }}
//       >
//         {icon}
//       </Box>
//       <Typography
//         sx={{ fontSize: "0.8rem", color: "#555", fontWeight: 500 }}
//       >
//         {label}
//       </Typography>
//     </Box>
//     <Typography
//       sx={{ fontSize: "0.84rem", fontWeight: 700, color: "#222" }}
//     >
//       {value}
//     </Typography>
//   </Box>
// );

// export default JDJVPropertyDetail;


// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Typography,
//   Box,
//   Button,
//   IconButton,
//   Divider,
//   CircularProgress,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import SearchIcon from "@mui/icons-material/Search";
// import HomeWorkIcon from "@mui/icons-material/HomeWork";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MapIcon from "@mui/icons-material/Map";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import PercentIcon from "@mui/icons-material/Percent";
// import StraightenIcon from "@mui/icons-material/Straighten";
// import HeightIcon from "@mui/icons-material/Height";
// import PersonIcon from "@mui/icons-material/Person";
// import AddRoadIcon from "@mui/icons-material/AddRoad";
// import ExploreIcon from "@mui/icons-material/Explore";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CallIcon from "@mui/icons-material/Call";
// import TagIcon from "@mui/icons-material/Tag";
// import { BASE_URL } from "../../Api/ApiUrls";
// import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";

// // ✅ NEW: Add the AddPropertyCards component
// import AddPropertyCards from "../AddsProducts/AddPropertyCards";

// const JDJVPropertyDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [locationLoading, setLocationLoading] = useState(false);
//   const [detailsExpanded, setDetailsExpanded] = useState(true);

//   useEffect(() => {
//     const fetchProperty = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${BASE_URL}/property/${id}/`);
//         setProperty(res.data.data || res.data);
//       } catch (err) {
//         console.error("Error fetching property:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProperty();
//   }, [id]);

//   const formatPropertyId = (id) => `PR${String(id).padStart(4, "0")}`;

//   const formatPrice = (amount) => {
//     if (!amount || amount === 0) return "Not specified";
//     if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(1)} Cr`;
//     if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)} L`;
//     return `₹${amount.toLocaleString()}`;
//   };

//   const handleLocationClick = () => {
//     if (!property) {
//       window.alert("Property data not available");
//       return;
//     }
//     const lat = property.lat;
//     const lng = property.long;
//     if (!lat || !lng) {
//       window.alert("Location coordinates not available");
//       return;
//     }
//     setLocationLoading(true);
//     const openInMaps = (url) => {
//       setLocationLoading(false);
//       window.open(url, "_blank", "noopener,noreferrer");
//     };
//     const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//       `${lat},${lng}`
//     )}`;
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${position.coords.latitude},${position.coords.longitude}&destination=${lat},${lng}&travelmode=driving`;
//           openInMaps(mapsUrl);
//         },
//         () => openInMaps(fallbackUrl),
//         { timeout: 10000 }
//       );
//     } else {
//       openInMaps(fallbackUrl);
//     }
//   };

//   // ✅ Contact handler — copies the mobile number to clipboard
//   const handleContactClick = async () => {
//     if (!property) return;
//     const mobile = property.mobile_no || property.mobile || property.phone;
//     if (!mobile) {
//       window.alert("Mobile number not available");
//       return;
//     }
//     try {
//       await navigator.clipboard.writeText(mobile);
//       window.alert(`Contact number copied: ${mobile}`);
//     } catch (err) {
//       console.error("Clipboard error:", err);
//       window.alert(`Contact number: ${mobile}`);
//     }
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//           backgroundColor: "#F8F3EC",
//         }}
//       >
//         <CircularProgress sx={{ color: "#8A6A3D" }} />
//       </Box>
//     );
//   }

//   if (!property) {
//     return (
//       <Box sx={{ p: 2, textAlign: "center", backgroundColor: "#F8F3EC", minHeight: "100vh" }}>
//         <Typography>JD/JV Property not found</Typography>
//       </Box>
//     );
//   }

//   const displayId = property.property_id || property.req_id;
//   const propertyLocation = property.location || "Not specified";
//   const dateStr = property.created_at
//     ? new Date(property.created_at).toLocaleDateString("en-GB")
//     : "-";

//   return (
//     <Box
//       sx={{
//         width: "100vw",
//         minHeight: "100vh",
//         backgroundColor: "#F8F3EC",
//         pb: 10,
//       }}
//     >
//       {/* ===== FIXED HEADER (dark brown) ===== */}
//       <Box
//         sx={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 10,
//           bgcolor: "#3E2A1E",
//           color: "white",
//           px: 2,
//           py: 1.5,
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <IconButton
//           onClick={() => navigate(-1)}
//           sx={{ color: "white", mr: 1, p: 0.5 }}
//         >
//           <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
//         </IconButton>
//         <Typography
//           sx={{
//             flex: 1,
//             fontSize: "1rem",
//             fontWeight: 600,
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           JD/JV Property
//         </Typography>
//       </Box>

//       {/* ===== BODY ===== */}
//       <Box sx={{ pt: "60px", px: 1 }}>
//         {/* ── Budget Range card ── */}
//         <Box
//           sx={{
//             bgcolor: "#FFFFFF",
//             border: "1px solid #E8DCC8",
//             borderRadius: "12px",
//             p: 1.5,
//             mb: 1.5,
//             display: "flex",
//             alignItems: "center",
//             gap: 1.2,
//           }}
//         >
//           <Box
//             sx={{
//               width: 42,
//               height: 42,
//               borderRadius: "50%",
//               backgroundColor: "#FBF5ED",
//               border: "1px solid #E8DCC8",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <MonetizationOnIcon sx={{ color: "#8A6A3D", fontSize: 22 }} />
//           </Box>

//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Budget Range
//             </Typography>
//             <Typography
//               sx={{
//                 color: "#5C3D1E",
//                 fontWeight: 800,
//                 fontSize: "1rem",
//                 lineHeight: 1.2,
//               }}
//             >
//               {formatPrice(property.min_budget)} - {formatPrice(property.max_budget)}
//             </Typography>
//           </Box>

//           <Divider
//             orientation="vertical"
//             flexItem
//             sx={{ mx: 0.5, borderColor: "#E8DCC8" }}
//           />

//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               flexShrink: 0,
//             }}
//           >
//             <Box
//               sx={{
//                 width: 36,
//                 height: 36,
//                 borderRadius: "50%",
//                 backgroundColor: "#FBF5ED",
//                 border: "1px solid #E8DCC8",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <BarChartIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
//             </Box>
//             <Box>
//               <Typography
//                 sx={{
//                   fontSize: "0.78rem",
//                   fontWeight: 700,
//                   color: "#222",
//                   lineHeight: 1.1,
//                 }}
//               >
//                 {property.property_type || "Plot"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.66rem", color: "#777" }}>
//                 Property Type
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* ── Looking for ── */}
//         <InfoIconRow
//           icon={<SearchIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />}
//           label="Looking for:"
//           value={property.type ? property.type.toUpperCase() : "Not specified"}
//         />

//         {/* ── Property type + View on Map ── */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
//           <IconCircle>
//             <HomeWorkIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
//           </IconCircle>
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Property type:
//             </Typography>
//             <Typography
//               sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}
//             >
//               {property.property_type || "Not specified"}
//             </Typography>
//           </Box>
//           <Button
//             size="small"
//             onClick={handleLocationClick}
//             startIcon={<MapIcon sx={{ fontSize: 14 }} />}
//             sx={{
//               textTransform: "none",
//               fontSize: "0.72rem",
//               fontWeight: 600,
//               color: "#5C3D1E",
//               backgroundColor: "#F5DEB3",
//               border: "1px solid #E8C99A",
//               borderRadius: 999,
//               px: 1.2,
//               py: 0.4,
//               "&:hover": { backgroundColor: "#eccf95" },
//             }}
//           >
//             View on Map
//           </Button>
//         </Box>

//         {/* ── Location ── */}
//         <Box
//           onClick={handleLocationClick}
//           sx={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: 1.2,
//             mb: 2,
//             cursor: "pointer",
//             borderRadius: 1,
//             p: 0.4,
//             "&:hover": { backgroundColor: "#F0E6D6" },
//           }}
//         >
//           <IconCircle>
//             {locationLoading ? (
//               <CircularProgress size={14} sx={{ color: "#8A6A3D" }} />
//             ) : (
//               <LocationOnIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
//             )}
//           </IconCircle>
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
//               Location:
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.85rem",
//                 fontWeight: 600,
//                 color: "#222",
//                 lineHeight: 1.3,
//               }}
//             >
//               {propertyLocation}
//             </Typography>
//           </Box>
//         </Box>

//         {/* ✅ NEW: Add Property Cards (advertisements) — placed above Property Details */}
//         <Box sx={{ mb: 1.5 }}>
//           <AddPropertyCards panel="jvjd" />
//         </Box>

//         {/* ── Property Details (collapsible) ── */}
//         <Box sx={{ mb: 1.5 }}>
//           <Accordion
//             expanded={detailsExpanded}
//             onChange={() => setDetailsExpanded(!detailsExpanded)}
//             sx={{
//               borderRadius: "12px !important",
//               border: "1px solid #E8DCC8",
//               boxShadow: "none",
//               bgcolor: "#FFFFFF",
//               "&:before": { display: "none" },
//               "&.Mui-expanded": { margin: 0 },
//             }}
//           >
//             <AccordionSummary
//               expandIcon={<ExpandMoreIcon sx={{ color: "#8A6A3D" }} />}
//               sx={{ px: 1.5, minHeight: 48, "&.Mui-expanded": { minHeight: 48 } }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                 <ApartmentIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
//                 <Typography
//                   sx={{ fontSize: "0.95rem", fontWeight: 700, color: "#222" }}
//                 >
//                   Property Details
//                 </Typography>
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails sx={{ px: 1.5, pt: 0 }}>
//               <Box sx={{ borderTop: "1px solid #F0E6D6", pt: 1.2 }}>
//                 {/* Property ID row */}
//                 {displayId && (
//                   <DetailRow
//                     icon={<TagIcon sx={{ fontSize: 14 }} />}
//                     label="Property ID"
//                     value={formatPropertyId(displayId)}
//                   />
//                 )}

//                 <DetailRow
//                   icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
//                   label="Minimum Budget"
//                   value={formatPrice(property.min_budget)}
//                 />
//                 <DetailRow
//                   icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
//                   label="Maximum Budget"
//                   value={formatPrice(property.max_budget)}
//                 />
//                 {property.ratio && (
//                   <DetailRow
//                     icon={<PercentIcon sx={{ fontSize: 14 }} />}
//                     label="JV/JD Ratio"
//                     value={property.ratio}
//                   />
//                 )}
//                 {property.length > 0 && (
//                   <DetailRow
//                     icon={<StraightenIcon sx={{ fontSize: 14 }} />}
//                     label="Length"
//                     value={`${property.length} ft`}
//                   />
//                 )}
//                 {property.width > 0 && (
//                   <DetailRow
//                     icon={<HeightIcon sx={{ fontSize: 14 }} />}
//                     label="Width"
//                     value={`${property.width} ft`}
//                   />
//                 )}
//                 {property.posted_by && (
//                   <DetailRow
//                     icon={<PersonIcon sx={{ fontSize: 14 }} />}
//                     label="Posted By"
//                     value={property.posted_by}
//                   />
//                 )}
//                 {(property.roadwidth > 0 || property.road_width > 0) && (
//                   <DetailRow
//                     icon={<AddRoadIcon sx={{ fontSize: 14 }} />}
//                     label="Road Width"
//                     value={`${property.roadwidth || property.road_width} ft`}
//                   />
//                 )}
//                 {property.facing && (
//                   <DetailRow
//                     icon={<ExploreIcon sx={{ fontSize: 14 }} />}
//                     label="Facing"
//                     value={property.facing}
//                   />
//                 )}
//                 <DetailRow
//                   icon={<CalendarTodayIcon sx={{ fontSize: 14 }} />}
//                   label="Date"
//                   value={
//                     property.created_at
//                       ? new Date(property.created_at).toLocaleDateString(
//                           "en-IN",
//                           {
//                             day: "2-digit",
//                             month: "2-digit",
//                             year: "numeric",
//                           }
//                         )
//                       : "-"
//                   }
//                 />

//                 {/* Contact button inside Property Details */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     mt: 1.5,
//                   }}
//                 >
//                   <Button
//                     size="small"
//                     variant="contained"
//                     onClick={handleContactClick}
//                     startIcon={<CallIcon sx={{ fontSize: 15 }} />}
//                     sx={{
//                       textTransform: "none",
//                       fontSize: "0.78rem",
//                       fontWeight: 700,
//                       color: "#FFFFFF",
//                       backgroundColor: "#8A6A3D",
//                       borderRadius: 999,
//                       px: 2,
//                       py: 0.6,
//                       boxShadow: "0 2px 6px rgba(138,106,61,0.35)",
//                       "&:hover": { backgroundColor: "#75592F" },
//                     }}
//                   >
//                     Contact
//                   </Button>
//                 </Box>
//               </Box>
//             </AccordionDetails>
//           </Accordion>
//         </Box>
//       </Box>

//       {/* Fixed bottom nav */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
//         <FormsBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// /* ───────── Reusable subcomponents ───────── */

// const IconCircle = ({ children }) => (
//   <Box
//     sx={{
//       width: 36,
//       height: 36,
//       borderRadius: "50%",
//       backgroundColor: "#FBF5ED",
//       border: "1px solid #E8DCC8",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexShrink: 0,
//     }}
//   >
//     {children}
//   </Box>
// );

// const InfoIconRow = ({ icon, label, value }) => (
//   <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
//     <IconCircle>{icon}</IconCircle>
//     <Box sx={{ flex: 1, minWidth: 0 }}>
//       <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>{label}</Typography>
//       <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}>
//         {value}
//       </Typography>
//     </Box>
//   </Box>
// );

// const DetailRow = ({ icon, label, value }) => (
//   <Box
//     sx={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       py: 1.1,
//       borderBottom: "1px solid #F0E6D6",
//       "&:last-of-type": { borderBottom: "none" },
//     }}
//   >
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//       <Box
//         sx={{
//           width: 26,
//           height: 26,
//           borderRadius: "50%",
//           backgroundColor: "#FBF5ED",
//           border: "1px solid #E8DCC8",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "#8A6A3D",
//           flexShrink: 0,
//         }}
//       >
//         {icon}
//       </Box>
//       <Typography
//         sx={{ fontSize: "0.8rem", color: "#555", fontWeight: 500 }}
//       >
//         {label}
//       </Typography>
//     </Box>
//     <Typography
//       sx={{ fontSize: "0.84rem", fontWeight: 700, color: "#222" }}
//     >
//       {value}
//     </Typography>
//   </Box>
// );

// export default JDJVPropertyDetail;



import React, { useEffect, useState, useContext } from "react";
import HomeIcon from '@mui/icons-material/Home';
import {
  Card,
  Typography,
  Box,
  Button,
  CardContent,
  IconButton,
  Divider,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  CheckCircle, Security, Bolt, Groups, Pool, FitnessCenter, SportsEsports,
  DirectionsRun, ChildCare, Park, SelfImprovement, MeetingRoom, Theaters, Work,
  ElectricCar, LocalParking, Water, Videocam, ChildFriendly, Spa, HotTub,
  SportsTennis, SportsBasketball, SportsCricket, SportsSoccer, DirectionsBike,
  LocalLibrary, LocalCafe, Event, Hotel, Texture, Kitchen, Bathtub, FormatPaint,
  Train, Flight, DirectionsBus, School, LocalHospital, ShoppingCart,
  ApartmentOutlined, Description, Gavel, AccountBalance,
} from '@mui/icons-material';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import BarChartIcon from "@mui/icons-material/BarChart";
import MapIcon from "@mui/icons-material/Map";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import StraightenIcon from "@mui/icons-material/Straighten";
import HeightIcon from "@mui/icons-material/Height";
import PersonIcon from "@mui/icons-material/Person";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import ExploreIcon from "@mui/icons-material/Explore";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CallIcon from "@mui/icons-material/Call";
import TagIcon from "@mui/icons-material/Tag";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";

import { BASE_URL } from "../../Api/ApiUrls";
import { AuthContext } from "../../AuthContext/AuthContext";
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";

// ✅ NEW: Add the AddPropertyCards component
import AddPropertyCards from "../AddsProducts/AddPropertyCards";

// ✅ NEW: Alerts + Guest modal
import CopySuccessAlert from "../Alertpage/CopyAlert/CopySuccessAlert";
import CopyFailureAlert from "../Alertpage/CopyAlert/CopyFailureAlert";
import GuestLoginModal from "../../GuestLoginModal";
import PhoneModal from './PhoneModal';   // adjust path if needed
import MapModal from './MapModal';       // adjust path if needed
import ShareModal from '../Buy Module/ShareModal';   // adjust path if needed

const COLORS = {
  primary: '#8B4A2B', primaryDark: '#6B3620', cardBg: '#FFFFFF',
  blue: '#1565C0', textSecondary: '#8A7A6D', textDark: '#2B2118', border: '#F0E6DA',
};

const AMENITY_CATEGORIES = [
  "Recreation", "Fitness & Wellness", "Sports", "Security",
  "Utilities", "Building Facilities", "Family & Convenience",
];

const AMENITY_CATEGORY_MAP = {
  "Swimming Pool": "Recreation", "Kids Pool": "Recreation", "Club House": "Recreation",
  "Indoor Games": "Recreation", "Mini Theatre": "Recreation", "Party Hall": "Recreation",
  "Library": "Recreation", "Cafe": "Recreation", "Guest Rooms": "Recreation",
  "Gym": "Fitness & Wellness", "Yoga Room": "Fitness & Wellness", "Jogging Track": "Fitness & Wellness",
  "Cycling Track": "Fitness & Wellness", "Spa": "Fitness & Wellness", "Sauna": "Fitness & Wellness",
  "Steam Room": "Fitness & Wellness", "Meditation Area": "Fitness & Wellness", "Fitness Centre": "Fitness & Wellness",
  "Tennis Court": "Sports", "Basketball Court": "Sports", "Badminton Court": "Sports",
  "Cricket Net": "Sports", "Football Field": "Sports", "Table Tennis": "Sports",
  "Volleyball Court": "Sports", "Skating Area": "Sports", "Kids Play Area": "Sports",
  "24x7 Security": "Security", "CCTV Surveillance": "Security", "Video Door Phone": "Security",
  "Intercom": "Security", "Gated Entry": "Security", "Visitor Mgmt": "Security",
  "Fire Safety": "Security", "Access Control": "Security", "Emergency Exit": "Security",
  "Power Backup": "Utilities", "Water Supply": "Utilities", "Rainwater Harvesting": "Utilities",
  "Sewage Treatment": "Utilities", "Waste Mgmt": "Utilities", "Solar Power": "Utilities",
  "EV Charging": "Utilities", "Gas Pipeline": "Utilities", "STP / WTP": "Utilities",
  "High Speed Lift": "Building Facilities", "Lobby": "Building Facilities", "Reception": "Building Facilities",
  "Waiting Area": "Building Facilities", "Basement Parking": "Building Facilities",
  "Maintenance": "Building Facilities", "Housekeeping": "Building Facilities",
  "Service Lift": "Building Facilities", "Common Terrace": "Building Facilities",
  "Creche/Day Care": "Family & Convenience", "Senior Citizen Area": "Family & Convenience",
  "Convenience Store": "Family & Convenience", "Pharmacy": "Family & Convenience",
  "ATM": "Family & Convenience", "Salon": "Family & Convenience", "Laundry": "Family & Convenience",
  "Medical Centre": "Family & Convenience",
};

const CATEGORY_KEYWORDS = [
  { cat: "Recreation", keys: ["pool", "club house", "indoor games", "mini theatre", "party hall", "library", "cafe", "guest room"] },
  { cat: "Fitness & Wellness", keys: ["gym", "yoga", "jogging", "cycling", "spa", "sauna", "steam", "meditation", "fitness"] },
  { cat: "Sports", keys: ["tennis", "basketball", "badminton", "cricket", "football", "table tennis", "volleyball", "skating", "kids play", "play area"] },
  { cat: "Security", keys: ["security", "cctv", "video door", "intercom", "gated entry", "visitor", "fire safety", "access control", "emergency exit"] },
  { cat: "Utilities", keys: ["power backup", "water supply", "rainwater", "rain water", "sewage", "waste", "solar", "ev charging", "gas pipeline", "stp", "wtp"] },
  { cat: "Building Facilities", keys: ["lift", "lobby", "reception", "waiting", "basement parking", "maintenance", "housekeeping", "terrace"] },
  { cat: "Family & Convenience", keys: ["creche", "day care", "senior citizen", "convenience", "store", "pharmacy", "atm", "salon", "laundry", "medical"] },
];

const getAmenityCategory = (name = "") => {
  if (AMENITY_CATEGORY_MAP[name]) return AMENITY_CATEGORY_MAP[name];
  const lower = String(name).toLowerCase();
  for (const { cat, keys } of CATEGORY_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return cat;
  }
  return "Other";
};

const groupAmenitiesByCategory = (amenities = []) => {
  const groups = {};
  amenities.forEach((name) => {
    const cat = getAmenityCategory(name);
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(name);
  });
  return groups;
};

const ICON_KEYWORDS = [
  { keys: ['security', 'cctv', 'guard', '24'], icon: Security },
  { keys: ['power', 'backup', 'electrical', 'bolt'], icon: Bolt },
  { keys: ['club', 'community'], icon: Groups },
  { keys: ['swim', 'pool'], icon: Pool },
  { keys: ['gym', 'fitness'], icon: FitnessCenter },
  { keys: ['indoor', 'game', 'sports esports'], icon: SportsEsports },
  { keys: ['jog', 'run', 'track'], icon: DirectionsRun },
  { keys: ['child', 'kid', 'play'], icon: ChildCare },
  { keys: ['senior', 'park', 'garden', 'landscape'], icon: Park },
  { keys: ['yoga', 'meditation'], icon: SelfImprovement },
  { keys: ['multipurpose', 'hall', 'banquet', 'party'], icon: MeetingRoom },
  { keys: ['theatre', 'theater', 'cinema'], icon: Theaters },
  { keys: ['co-work', 'cowork', 'office', 'business', 'lounge'], icon: Work },
  { keys: ['ev', 'electric', 'charging'], icon: ElectricCar },
  { keys: ['visitor', 'parking'], icon: LocalParking },
  { keys: ['rain', 'water', 'harvest'], icon: Water },
  { keys: ['cctv', 'camera', 'surveillance'], icon: Videocam },
  { keys: ['kids pool', 'child pool'], icon: ChildFriendly },
  { keys: ['spa'], icon: Spa },
  { keys: ['sauna', 'hot tub', 'jacuzzi'], icon: HotTub },
  { keys: ['badminton', 'tennis'], icon: SportsTennis },
  { keys: ['basketball'], icon: SportsBasketball },
  { keys: ['cricket', 'net'], icon: SportsCricket },
  { keys: ['football', 'soccer', 'turf'], icon: SportsSoccer },
  { keys: ['cycling', 'bike'], icon: DirectionsBike },
  { keys: ['library', 'reading'], icon: LocalLibrary },
  { keys: ['cafe', 'coffee'], icon: LocalCafe },
  { keys: ['event', 'auditorium'], icon: Event },
  { keys: ['hotel', 'guest', 'room'], icon: Hotel },
  { keys: ['flooring', 'floor', 'texture'], icon: Texture },
  { keys: ['kitchen', 'modular'], icon: Kitchen },
  { keys: ['bathroom', 'bath', 'toilet'], icon: Bathtub },
  { keys: ['painting', 'paint'], icon: FormatPaint },
  { keys: ['smart', 'home', 'automation'], icon: HomeIcon },
  { keys: ['door', 'window'], icon: MeetingRoom },
  { keys: ['metro', 'train', 'railway'], icon: Train },
  { keys: ['airport', 'flight'], icon: Flight },
  { keys: ['bus', 'transit'], icon: DirectionsBus },
  { keys: ['school', 'college', 'education'], icon: School },
  { keys: ['hospital', 'clinic', 'medical'], icon: LocalHospital },
  { keys: ['mall', 'shopping', 'market'], icon: ShoppingCart },
  { keys: ['it park', 'tech', 'office park'], icon: ApartmentOutlined },
  { keys: ['brochure', 'document', 'pdf'], icon: Description },
  { keys: ['legal', 'rera', 'approval'], icon: Gavel },
  { keys: ['bank', 'loan', 'finance'], icon: AccountBalance },
];

const resolveIcon = (label = '') => {
  const lower = String(label).toLowerCase();
  for (const { keys, icon } of ICON_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return icon;
  }
  return CheckCircle;
};

const IconGrid = ({ items, emptyText }) => {
  if (!items || items.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 1 }}>
        {emptyText || 'Not available'}
      </Typography>
    );
  }
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
      {items.map((raw) => {
        const name = typeof raw === 'string' ? raw : raw.name;
        const IconComp = resolveIcon(name);
        return (
          <Box
            key={name}
            sx={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
              borderRadius: '10px', border: `1px solid ${COLORS.border}`,
              backgroundColor: COLORS.cardBg, minHeight: '60px', justifyContent: 'center', overflow: 'hidden',
            }}
          >
            <IconComp sx={{ fontSize: 24, color: COLORS.primary }} />
            <Typography sx={{ fontSize: '10.5px', fontWeight: 600, color: COLORS.textDark, lineHeight: 1.2, wordBreak: 'break-word' }}>
              {name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

const SectionHeaderWithViewAll = ({ title, onViewAll, expanded }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>{title}</Typography>
    {onViewAll && (
      <Typography variant="body2" onClick={onViewAll} sx={{ color: COLORS.blue, fontWeight: 600, cursor: 'pointer' }}>
        {expanded ? 'Show Less' : 'View All'}
      </Typography>
    )}
  </Box>
);

const EmptyText = ({ children }) => (
  <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
    {children}
  </Typography>
);

const JDJVPropertyDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { userId, isGuest } = useContext(AuthContext);

  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [locationLoading, setLocationLoading] = useState(false);
  const [detailsExpanded, setDetailsExpanded] = useState(true);
    const [showAllHighlights, setShowAllHighlights] = useState(false);
  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState('All');
  

  // ===== Wishlist + Share state =====
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [wishlistLoading, setWishlistLoading] = useState(false);
  const [cartItemId, setCartItemId] = useState(null);
  const [showGuestModal, setShowGuestModal] = useState(false);

  // ===== Alert state =====
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
const [showPhoneModal, setShowPhoneModal] = useState(false);
const [showMapModal, setShowMapModal] = useState(false);
const [showShareModal, setShowShareModal] = useState(false);
  useEffect(() => {
    const fetchProperty = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${BASE_URL}/property/${id}/`);
        setProperty(res.data.data || res.data);
      } catch (err) {
        console.error("Error fetching property:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProperty();
  }, [id]);

  // ─────────────────────────────────────────────────────────────
  // Wishlist check
  // ─────────────────────────────────────────────────────────────
  useEffect(() => {
    const checkWishlist = async () => {
      if (!userId || !id) return;
      try {
        const response = await axios.get(`${BASE_URL}/get-user-cart/${userId}/`);
        const items = Array.isArray(response.data) ? response.data : [];
        const match = items.find((item) => String(item.property_id) === String(id));
        if (match) {
          setIsWishlisted(true);
          setCartItemId(match.cart_id || match.id);
        } else {
          setIsWishlisted(false);
          setCartItemId(null);
        }
      } catch (err) {
        console.error("Wishlist check failed:", err);
      }
    };
    checkWishlist();
  }, [userId, id]);

  // ─────────────────────────────────────────────────────────────
  // Wishlist toggle
  // ─────────────────────────────────────────────────────────────
  const handleWishlistToggle = async () => {
    if (isGuest || !userId) {
      setShowGuestModal(true);
      return;
    }

    setWishlistLoading(true);
    try {
      if (isWishlisted) {
        if (cartItemId) {
          await axios.delete(`${BASE_URL}/user-cart/${cartItemId}/`);
        }
        setIsWishlisted(false);
        setCartItemId(null);
        setAlertMessage("Removed from wishlist");
        setShowSuccess(true);
      } else {
        const res = await axios.post(`${BASE_URL}/user-cart/`, {
          user_id: userId,
          property_id: id,
        });
        setIsWishlisted(true);
        setCartItemId(res.data?.cart_id || res.data?.id || null);
        setAlertMessage("Added to wishlist");
        setShowSuccess(true);
      }
    } catch (err) {
      console.error("Wishlist toggle failed:", err);
      setAlertMessage("Failed to update wishlist");
      setShowFailure(true);
    } finally {
      setWishlistLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────
  // Share
  // ─────────────────────────────────────────────────────────────
  const handleShareClick = () => {
  if (isGuest || !userId) {
    setShowGuestModal(true);
    return;
  }
  setShowShareModal(true);
};

  const formatPropertyId = (id) => `PR${String(id).padStart(4, "0")}`;

  const formatPrice = (amount) => {
    if (!amount || amount === 0) return "Not specified";
    if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(1)} Cr`;
    if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)} L`;
    return `₹${amount.toLocaleString()}`;
  };

  // ─────────────────────────────────────────────────────────────
  // Time ago
  // ─────────────────────────────────────────────────────────────
  const formatTimeAgo = (dateString) => {
    if (!dateString) return "";
    const now = new Date();
    const then = new Date(dateString);
    const diffMs = now - then;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    if (diffMins < 1) return "just now";
    if (diffMins < 60) return `${diffMins} min ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
    if (diffDays < 30) return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
    if (diffMonths < 12) return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
    return `${diffYears} year${diffYears > 1 ? "s" : ""} ago`;
  };

  const getSellerName = (p) => {
    const first = p?.user_first_name?.trim();
    const last = p?.user_last_name?.trim();
    if (first || last) return `${first || ""} ${last || ""}`.trim();
    return p?.posted_by || "Owner";
  };

  // ─────────────────────────────────────────────────────────────
  // Map
  // ─────────────────────────────────────────────────────────────
 // ── View on Map → open MapModal ────────────────────────────────────────────
const handleOpenMapLocation = () => {
  if (isGuest || !userId) {
    setShowGuestModal(true);
    return;
  }
  setShowMapModal(true);
};

// Called only when user confirms "Open Map" in MapModal
const executeOpenMap = () => {
  setShowMapModal(false);
  if (!property) return;

  const lat = property.lat;
  const lng = property.long ?? property.lng;

  const fallback = property.location
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`
    : lat && lng
      ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
      : null;

  if (!fallback && !(lat && lng)) {
    setAlertMessage('Location not available');
    setShowFailure(true);
    return;
  }

  setLocationLoading(true);

  const open = (url) => {
    setLocationLoading(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (navigator.geolocation && lat && lng) {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        open(
          `https://www.google.com/maps/dir/?api=1&origin=${coords.latitude},${coords.longitude}&destination=${lat},${lng}&travelmode=driving`
        );
      },
      () => open(fallback),
      { timeout: 10000 }
    );
  } else {
    open(fallback);
  }
};

  // ─────────────────────────────────────────────────────────────
  // Contact (copy mobile)
  // ─────────────────────────────────────────────────────────────
  // ── View Number → open PhoneModal ──────────────────────────────────────────
const handleViewNumberClick = () => {
  if (isGuest || !userId) {
    setShowGuestModal(true);
    return;
  }
  setShowPhoneModal(true);
};

  // ─────────────────────────────────────────────────────────────
  // WhatsApp chat
  // ─────────────────────────────────────────────────────────────
  const handleWhatsAppClick = () => {
    const mobile = property?.mobile_no || property?.mobile || property?.phone;
    if (!mobile) {
      setAlertMessage("Mobile number not available");
      setShowFailure(true);
      return;
    }
    const cleanNumber = String(mobile).replace(/\D/g, "");
    const waNumber = cleanNumber.startsWith("91") ? cleanNumber : `91${cleanNumber}`;
    const message = encodeURIComponent(
      `Hi, I am interested in your JD/JV property (ID: ${property.id || id}). Please share more details.`
    );
    window.open(`https://wa.me/${waNumber}?text=${message}`, "_blank");
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#F8F3EC",
        }}
      >
        <CircularProgress sx={{ color: "#8A6A3D" }} />
      </Box>
    );
  }

  if (!property) {
    return (
      <Box sx={{ p: 2, textAlign: "center", backgroundColor: "#F8F3EC", minHeight: "100vh" }}>
        <Typography>JD/JV Property not found</Typography>
      </Box>
    );
  }

  const displayId = property.property_id || property.req_id;

  const uniqueNames = (list = []) => [
  ...new Set(list.map((x) => (x?.name || '').trim()).filter(Boolean)),
];

const highlightNames = uniqueNames(property.property_highlights);
const amenityNames = uniqueNames(property.property_amenities);

const visibleHighlights = showAllHighlights ? highlightNames : highlightNames.slice(0, 8);

const amenityGroups = groupAmenitiesByCategory(amenityNames);
const presentAmenityCategories = AMENITY_CATEGORIES.filter((c) => amenityGroups[c]?.length > 0);
if (amenityGroups["Other"]?.length) presentAmenityCategories.push("Other");

const amenityCategoriesToShow =
  selectedAmenityCategory === 'All'
    ? presentAmenityCategories
    : presentAmenityCategories.filter((c) => c === selectedAmenityCategory);

  const propertyLocation = property.location || "Not specified";

  return (
    <Box
      sx={{
        width: "100vw",
        minHeight: "100vh",
        backgroundColor: "#F8F3EC",
        pb: 10,
      }}
    >
      {/* ===== FIXED HEADER (dark brown) ===== */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          bgcolor: "#3E2A1E",
          color: "white",
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ color: "white", mr: 1, p: 0.5 }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <Typography
          sx={{
            flex: 1,
            fontSize: "1rem",
            fontWeight: 600,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          JD/JV Property
        </Typography>
      </Box>

      {/* ===== BODY ===== */}
      <Box sx={{ pt: "60px", px: 1 }}>
        {/* ── Budget Range card ── */}
        <Box
          sx={{
            bgcolor: "#FFFFFF",
            border: "1px solid #E8DCC8",
            borderRadius: "12px",
            p: 1.5,
            mb: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 1.2,
          }}
        >
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: "50%",
              backgroundColor: "#FBF5ED",
              border: "1px solid #E8DCC8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <MonetizationOnIcon sx={{ color: "#8A6A3D", fontSize: 22 }} />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
              Budget Range
            </Typography>
            <Typography
              sx={{
                color: "#5C3D1E",
                fontWeight: 800,
                fontSize: "1rem",
                lineHeight: 1.2,
              }}
            >
              {formatPrice(property.min_budget)} - {formatPrice(property.max_budget)}
            </Typography>
          </Box>

          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 0.5, borderColor: "#E8DCC8" }}
          />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: "#FBF5ED",
                border: "1px solid #E8DCC8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <BarChartIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "0.78rem",
                  fontWeight: 700,
                  color: "#222",
                  lineHeight: 1.1,
                }}
              >
                {property.property_type || "Plot"}
              </Typography>
              <Typography sx={{ fontSize: "0.66rem", color: "#777" }}>
                Property Type
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ── PROPERTY ID + WISHLIST + SHARE ── */}
        <Box sx={{ mb: 1.5 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 0.8,
              flexWrap: "nowrap",
            }}
          >
            {/* Property ID Box */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                bgcolor: "#F5DEB3",
                border: "1px solid #E8C99A",
                borderRadius: "8px",
                px: 1,
                py: 0.5,
                flex: 1,
                minWidth: 0,
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  color: "#5C3D1E",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                Property Id :
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  color: "#5C3D1E",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {displayId ? formatPropertyId(displayId) : id}
              </Typography>
            </Box>

            {/* Wishlist Button */}
            <Tooltip title={isWishlisted ? "Remove from Wishlist" : "Add to Wishlist"}>
              <Box
                onClick={handleWishlistToggle}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.5,
                  bgcolor: "#FFF",
                  border: "1px solid #E8C99A",
                  borderRadius: "8px",
                  px: 1.2,
                  py: 0.5,
                  cursor: wishlistLoading ? "wait" : "pointer",
                  flexShrink: 0,
                  transition: "all 0.2s",
                  "&:hover": { bgcolor: "#FDF3E7" },
                }}
              >
                {wishlistLoading ? (
                  <CircularProgress size={16} sx={{ color: "#E53935" }} />
                ) : isWishlisted ? (
                  <Favorite sx={{ fontSize: 18, color: "#E53935" }} />
                ) : (
                  <FavoriteBorder sx={{ fontSize: 18, color: "#5C3D1E" }} />
                )}
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 700,
                    color: isWishlisted ? "#E53935" : "#5C3D1E",
                    whiteSpace: "nowrap",
                  }}
                >
                  {isWishlisted ? "Wishlisted" : "Wishlist"}
                </Typography>
              </Box>
            </Tooltip>

            {/* Share Button */}
            <Tooltip title="Share this property">
              <Box
                onClick={handleShareClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.5,
                  bgcolor: "#FFF",
                  border: "1px solid #E8C99A",
                  borderRadius: "8px",
                  px: 1.2,
                  py: 0.5,
                  cursor: "pointer",
                  flexShrink: 0,
                  transition: "all 0.2s",
                  "&:hover": { bgcolor: "#FDF3E7" },
                }}
              >
                <ShareIcon sx={{ fontSize: 18, color: "#5C3D1E" }} />
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 700,
                    color: "#5C3D1E",
                    whiteSpace: "nowrap",
                  }}
                >
                  Share
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </Box>

        {/* ── Looking for ── */}
        <InfoIconRow
          icon={<SearchIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />}
          label="Looking for:"
          value={property.type ? property.type.toUpperCase() : "Not specified"}
        />

        {/* ── Property type + View on Map ── */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
          <IconCircle>
            <HomeWorkIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
          </IconCircle>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
              Property type:
            </Typography>
            <Typography
              sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}
            >
              {property.property_type || "Not specified"}
            </Typography>
          </Box>
        </Box>

        {/* ── Location ── */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.2,
            mb: 2,
            borderRadius: 1,
            p: 0.4,
          }}
        >
          <IconCircle>
            <LocationOnIcon sx={{ fontSize: 16, color: "#8A6A3D" }} />
          </IconCircle>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>
              Location:
            </Typography>
            <Typography
              sx={{
                fontSize: "0.85rem",
                fontWeight: 600,
                color: "#222",
                lineHeight: 1.3,
              }}
            >
              {propertyLocation}
            </Typography>
          </Box>
        </Box>

        {/* ✅ NEW: Add Property Cards (advertisements) */}
        <Box sx={{ mb: 1.5 }}>
          <AddPropertyCards panel="jvjd" />
        </Box>

        {/* ── Property Details (collapsible) ── */}
        <Box sx={{ mb: 1.5 }}>
          <Accordion
            expanded={detailsExpanded}
            onChange={() => setDetailsExpanded(!detailsExpanded)}
            sx={{
              borderRadius: "12px !important",
              border: "1px solid #E8DCC8",
              boxShadow: "none",
              bgcolor: "#FFFFFF",
              "&:before": { display: "none" },
              "&.Mui-expanded": { margin: 0 },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#8A6A3D" }} />}
              sx={{ px: 1.5, minHeight: 48, "&.Mui-expanded": { minHeight: 48 } }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                <ApartmentIcon sx={{ color: "#8A6A3D", fontSize: 20 }} />
                <Typography
                  sx={{ fontSize: "0.95rem", fontWeight: 700, color: "#222" }}
                >
                  Property Details
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 1.5, pt: 0 }}>
              <Box sx={{ borderTop: "1px solid #F0E6D6", pt: 1.2 }}>
                {displayId && (
                  <DetailRow
                    icon={<TagIcon sx={{ fontSize: 14 }} />}
                    label="Property ID"
                    value={formatPropertyId(displayId)}
                  />
                )}

                <DetailRow
                  icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
                  label="Minimum Budget"
                  value={formatPrice(property.min_budget)}
                />
                <DetailRow
                  icon={<AttachMoneyIcon sx={{ fontSize: 14 }} />}
                  label="Maximum Budget"
                  value={formatPrice(property.max_budget)}
                />
                {property.ratio && (
                  <DetailRow
                    icon={<PercentIcon sx={{ fontSize: 14 }} />}
                    label="JV/JD Ratio"
                    value={property.ratio}
                  />
                )}
                {property.length > 0 && (
                  <DetailRow
                    icon={<StraightenIcon sx={{ fontSize: 14 }} />}
                    label="Length"
                    value={`${property.length} ft`}
                  />
                )}
                {property.width > 0 && (
                  <DetailRow
                    icon={<HeightIcon sx={{ fontSize: 14 }} />}
                    label="Width"
                    value={`${property.width} ft`}
                  />
                )}
                {property.posted_by && (
                  <DetailRow
                    icon={<PersonIcon sx={{ fontSize: 14 }} />}
                    label="Posted By"
                    value={property.posted_by}
                  />
                )}
                {(property.roadwidth > 0 || property.road_width > 0) && (
                  <DetailRow
                    icon={<AddRoadIcon sx={{ fontSize: 14 }} />}
                    label="Road Width"
                    value={`${property.roadwidth || property.road_width} ft`}
                  />
                )}
                {property.facing && (
                  <DetailRow
                    icon={<ExploreIcon sx={{ fontSize: 14 }} />}
                    label="Facing"
                    value={property.facing}
                  />
                )}
                <DetailRow
                  icon={<CalendarTodayIcon sx={{ fontSize: 14 }} />}
                  label="Date"
                  value={
                    property.created_at
                      ? new Date(property.created_at).toLocaleDateString("en-IN", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                      : "-"
                  }
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>

{highlightNames.length > 0 && (
  <Box sx={{ px: 0.5, mb: 1 }}>
    <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
      <CardContent sx={{ p: 0.5 }}>
        <SectionHeaderWithViewAll
          title="Property Highlights"
          onViewAll={highlightNames.length > 8 ? () => setShowAllHighlights(!showAllHighlights) : null}
          expanded={showAllHighlights}
        />
        <IconGrid items={visibleHighlights} emptyText="No highlights available for this property" />
      </CardContent>
    </Card>
  </Box>
)}

{/* ===== AMENITIES ===== */}
{amenityNames.length > 0 && (
  <Box sx={{ px: 0.5, mb: 1 }}>
    <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
      <CardContent sx={{ p: 0.5 }}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
          Amenities
        </Typography>

        <Box
          sx={{
            mb: 2, mt: 1, overflowX: 'auto', whiteSpace: 'nowrap',
            borderBottom: `1px solid ${COLORS.border}`,
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          <Box sx={{ display: 'inline-flex' }}>
            {['All', ...presentAmenityCategories].map((cat) => {
              const isActive = selectedAmenityCategory === cat;
              const count = cat === 'All' ? amenityNames.length : amenityGroups[cat]?.length || 0;
              return (
                <Box
                  key={cat}
                  onClick={() => setSelectedAmenityCategory(cat)}
                  sx={{
                    px: 1.5, py: 1, cursor: 'pointer', flexShrink: 0,
                    borderBottom: isActive ? `2px solid ${COLORS.primaryDark}` : '2px solid transparent',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '13px',
                      fontWeight: isActive ? 700 : 500,
                      color: isActive ? COLORS.primaryDark : COLORS.textSecondary,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {cat} ({count})
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

        {amenityCategoriesToShow.map((cat) => (
          <Box key={cat} sx={{ mb: 2 }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark, mb: 1 }}>
              {cat}
            </Typography>
            <IconGrid items={amenityGroups[cat]} />
          </Box>
        ))}
      </CardContent>
    </Card>
  </Box>
)}
        {/* ===== SELLER CARD ===== */}
        <Box sx={{ mb: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              bgcolor: "#FFFFFF",
              border: "1px solid #EEE",
              borderRadius: "12px",
              px: 1.5,
              py: 1.2,
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  bgcolor: "#a87c51",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  fontWeight: 700,
                  fontSize: "1rem",
                  overflow: "hidden",
                }}
              >
                {property?.user_first_name ? (
                  property.user_first_name.charAt(0).toUpperCase()
                ) : (
                  <PersonIcon sx={{ fontSize: 24 }} />
                )}
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    color: "#888",
                    lineHeight: 1.2,
                    fontWeight: 500,
                  }}
                >
                  Posted {formatTimeAgo(property?.created_at)} by
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 700,
                    color: "#222",
                    lineHeight: 1.25,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 180,
                  }}
                >
                  {getSellerName(property)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    color: "#666",
                    lineHeight: 1.2,
                  }}
                >
                  {property?.posted_by || "Owner"}
                </Typography>
              </Box>
            </Box>

            {/* <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                flexShrink: 0,
              }}
            >
              <Box
                onClick={handleWhatsAppClick}
                sx={{
                  bgcolor: "#a87c51",
                  color: "#fff",
                  px: 2,
                  py: 0.9,
                  borderRadius: "10px",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                  cursor: "pointer",
                  transition: "background 0.2s",
                  "&:hover": { bgcolor: "#a87c51" },
                }}
              >
                Chat now
              </Box>
              <Typography sx={{ fontSize: "0.65rem", color: "#888", mt: 0.4 }}>
                Free, fast &amp; secure
              </Typography>
            </Box> */}
          </Box>
        </Box>

        {/* ===== ACTION BUTTONS: View Number + View Location ===== */}
        <Box
          sx={{
            mb: 1.5,
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Box
            onClick={handleViewNumberClick}
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              bgcolor: "#FDF8F2",
              border: "1px solid #a87c51",
              borderRadius: "8px",
              px: 1,
              py: 1.2,
              cursor: "pointer",
              transition: "all 0.2s",
              "&:hover": { bgcolor: "#F5ECE0" },
            }}
          >
            <CallIcon sx={{ color: "#6B3620", fontSize: 22 }} />
            <Typography sx={{ fontSize: "0.8rem", fontWeight: 700, color: "#6B3620" }}>
              View Number
            </Typography>
          </Box>

          <Box
            onClick={handleOpenMapLocation}
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              bgcolor: "#FDF8F2",
              border: "1px solid #a87c51",
              borderRadius: "8px",
              px: 1,
              py: 1.2,
              cursor: "pointer",
              transition: "all 0.2s",
              "&:hover": { bgcolor: "#F5ECE0" },
            }}
          >
            {locationLoading ? (
              <CircularProgress size={20} sx={{ color: "#6B3620" }} />
            ) : (
              <LocationOnIcon sx={{ color: "#6B3620", fontSize: 22 }} />
            )}
            <Typography sx={{ fontSize: "0.8rem", fontWeight: 700, color: "#6B3620" }}>
              View on Map
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ===== ALERTS & MODALS ===== */}
      {showSuccess && (
        <CopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      {showFailure && (
        <CopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage("");
          }}
        />
      )}

      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />
      {/* Phone Modal – View Number */}
<PhoneModal
  open={showPhoneModal}
  onClose={() => setShowPhoneModal(false)}
  ownerName={getSellerName(property)}
  mobileNo={property?.mobile_no || property?.mobile || property?.phone}
/>

{/* Map Modal – View on Map */}
<MapModal
  open={showMapModal}
  onClose={() => setShowMapModal(false)}
  onOpenMap={executeOpenMap}
/>
{/* Share Modal */}
<ShareModal
  open={showShareModal}
  onClose={() => setShowShareModal(false)}
  ownerName={getSellerName(property)}
  mobileNo={property?.mobile_no || property?.mobile || property?.phone}
/>

      {/* Fixed bottom nav */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
};

/* ───────── Reusable subcomponents ───────── */

const IconCircle = ({ children }) => (
  <Box
    sx={{
      width: 36,
      height: 36,
      borderRadius: "50%",
      backgroundColor: "#FBF5ED",
      border: "1px solid #E8DCC8",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    {children}
  </Box>
);

const InfoIconRow = ({ icon, label, value }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1.2 }}>
    <IconCircle>{icon}</IconCircle>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: "0.7rem", color: "#777" }}>{label}</Typography>
      <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#222" }}>
        {value}
      </Typography>
    </Box>
  </Box>
);

const DetailRow = ({ icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      py: 1.1,
      borderBottom: "1px solid #F0E6D6",
      "&:last-of-type": { borderBottom: "none" },
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: "50%",
          backgroundColor: "#FBF5ED",
          border: "1px solid #E8DCC8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8A6A3D",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography sx={{ fontSize: "0.8rem", color: "#555", fontWeight: 500 }}>
        {label}
      </Typography>
    </Box>
    <Typography sx={{ fontSize: "0.84rem", fontWeight: 700, color: "#222" }}>
      {value}
    </Typography>
  </Box>
);

export default JDJVPropertyDetail;